// extracted by mini-css-extract-plugin
export var de = "ComponentTrustpilot-module--de--bb3ab";
export var fr = "ComponentTrustpilot-module--fr--724d6";
export var microStar = "ComponentTrustpilot-module--microStar--0ea5d";
export var microTrustScore = "ComponentTrustpilot-module--microTrustScore--776b3";
export var mini = "ComponentTrustpilot-module--mini--165e0";
export var nl = "ComponentTrustpilot-module--nl--df164";
export var wrapper = "ComponentTrustpilot-module--wrapper--a6796";